// node-modules
import Isotope from 'isotope-layout';
import LazyLoad from 'vanilla-lazyload';
import { SELECTORS } from '@/scripts/constants';
import { createEvent } from '@/scripts/utils';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
import _debounce from 'lodash/debounce';
import Accordion from 'accordion-js';
import '../accordion/accordion.scss';
import { photoCounter } from '../../scripts/_states';

const defaults = {
  el: null,
  filteredContent: '[data-role*="filtered-content"]',
  filteredItem: '[data-role*="filtered-item"]',
  filterItems: '[data-role*="filters-item"]',
  photosContainer: '[data-count-items]',
  photos: '[data-masonry-photo]',
  videos: '[data-masonry-video]',
  lineController: false,
  transitionDuration: 300,
};

export default class TabFilters {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.el = options.el;
    this.filteredContent = this.el.querySelector(options.filteredContent);
    this.filteredItem = options.filteredItem;
    this.filterItems = Array.from(this.el.querySelectorAll(options.filterItems));
    this.photosContainer = Array.from(this.el.querySelectorAll(options.photosContainer));
    this.transitionDuration = options.transitionDuration;
    this.lineController = options.lineController;
    this.defaultFilter = '*';
    this.photos = options.photos;
    this.videos = options.videos;
    this.filterBy = '';
    this.grid = null;
    this.activeClass = SELECTORS.active;
    this.hidenEyebrowContainer = document.querySelector('[data-hidden-eyebrow]');
    if (this.hidenEyebrowContainer) {
      this.hidenEyebrow = this.hidenEyebrowContainer.querySelector('h6');
    }

    this.updateGrid = this.updateGrid.bind(this);
    this.getActiveCategory = this.getActiveCategory.bind(this);
    this.updateGrid_debounced = _debounce(this.updateGrid, 100);
    this.filters = document.querySelectorAll('[data-filter]');
    this.init();
  }

  initGrid() {
    this.grid = new Isotope(this.filteredContent, {
      itemSelector: this.filteredItem,
      transitionDuration: this.transitionDuration,
      hiddenStyle: {
        opacity: 0,
        transform: 'scale(0.95)',
      },
      visibleStyle: {
        opacity: 1,
        transform: 'scale(1)',
      },
    });
    imagesLoaded(this.filteredContent).on('progress', () => {
      this.grid.layout();
    });
  }

  updateGrid() {
    this.grid.layout();
  }

  initFilters() {
    this.filterItems.forEach((item) => {
      item.addEventListener('click', () => {
        // if (e) e.preventDefault();
        this.filterBy = item.dataset.filter;
        $(this.filterItems).removeClass(this.activeClass);
        $(item).addClass(this.activeClass);
        if (this.lineController) {
          this.lineController.dispatchEvent(createEvent('updateLine'));
        }

        return this.filter();
      });
    });
  }

  filter() {
    const { filterBy, defaultFilter } = this;
    const dropdownList = document.querySelector('[data-dropdown-list]');
    const activeCategory = this.getActiveCategory();
    this.grid.arrange({
      filter(itemElem) {
        const { filterTags } = this ? this.dataset : itemElem.dataset; // ugly hotfix for itemElem is index instead of element
        // eslint-disable-next-line no-nested-ternary
        return filterBy === defaultFilter
          ? true : dropdownList && dropdownList.hasAttribute('data-use-categories') && activeCategory
            ? activeCategory === this.dataset.category && filterTags.includes(filterBy)
            : filterTags.includes(filterBy);
      },
    });
    window.dispatchEvent(createEvent('resize'));
  }

  masonry() {
    document.querySelectorAll('[data-masonry-photos-container]').forEach((el) => {
      // eslint-disable-next-line no-new
      new Isotope(el, {
        masonry: {
          itemSelector: this.photos,
          columnWidth: 100,
        },
      });
    });

    document.querySelectorAll('[data-masonry-videos-container]').forEach((el) => {
      // eslint-disable-next-line no-new
      new Isotope(el, {
        percentPosition: true,
        masonry: {
          itemSelector: this.videos,
          columnWidth: '.grid-sizer',
        },
      });
    });
  }

  changeTitle() {
    if (this.hidenEyebrowContainer) {
      this.hidenEyebrow.textContent = this.hidenEyebrowContainer.dataset.hiddenEyebrow;
    }
  }

  destroy() {
    window.removeEventListener('resize', this.updateGrid_debounced);
  }

  getActiveCategory() {
    const activeTab = [...this.filters].find(f => f.hasAttribute('data-active-tab'));

    return activeTab ? activeTab.dataset.filter : null;
  }

  init() {
    const accordions = document.querySelectorAll('[data-faq-accordion]');
    accordions.forEach((accordion) => {
      // eslint-disable-next-line no-new
      new Accordion(accordion, {
        onOpen: () => this.updateGrid(),
        onClose: () => this.updateGrid(),
      });
    });

    const signatures = document.querySelectorAll('[data-cover-signature-type]');
    const videoCount = document.querySelector('[data-cover-count-video]');
    const $3dCount = document.querySelector('[data-cover-count-3d]');
    const coverBg = document.querySelector('[data-cover-image]');
    this.filters.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        const coverTitle = document.querySelector('[data-paste-title]');
        const activeEyebrow = document.querySelector('[data-active-eyebrow]');
        if (coverTitle) {
          const h1 = coverTitle.querySelector('h1');
          h1.textContent = coverTitle.dataset.activeTitle;
        }
        if (activeEyebrow) {
          const eyebrow = activeEyebrow.querySelector('h6');
          eyebrow.textContent = activeEyebrow.dataset.activeEyebrow;
        }
        if (coverBg) {
          coverBg.src = coverBg.dataset.coverImage;
        }

        const activeSignature = [...signatures].find(signature => signature.dataset.coverSignatureType === e.target.dataset.filter);
        if (activeSignature && activeSignature.dataset.coverSignatureType !== 'photo') {
          signatures.forEach((signature) => {
            signature.classList.add('hide');
          });
          activeSignature.classList.remove('hide');
        } else {
          signatures.forEach((signature) => {
            signature.classList.add('hide');
          });
        }

        if (e.target.dataset.filter === 'video') {
          const videos = document.querySelectorAll('[data-gallery-video-card]');
          if (videoCount) {
            videoCount.textContent = videos.length;
          }
        }

        if (e.target.dataset.filter === '3d') {
          const $3d = document.querySelectorAll('[data-gallery-3d-card]');
          if (videoCount) {
            $3dCount.textContent = $3d.length;
          }
        }
      });
    });

    const albums = document.querySelectorAll('[data-choose-album]');
    albums.forEach((album) => {
      const dropdownList = document.querySelector('[data-dropdown-list]');
      const filterGridPhotos = document.querySelectorAll('[data-filter-tags]');
      if (dropdownList) {
        const dropdownTitle = dropdownList.querySelector('[data-dropdown-title]');
        const spanItems = document.querySelectorAll('[data-dropdown-title-item]');

        album.addEventListener('click', (e) => {
          e.preventDefault();
          window.scroll({
            top: album.getBoundingClientRect().top + window.pageYOffset - 300,
            behavior: 'smooth',
          });

          this.changeTitle();

          const albumTitle = e.target.querySelector('[data-gallery-title] p');
          if (albumTitle) {
            const coverTitle = document.querySelector('[data-paste-title] h1');
            if (coverTitle) {
              coverTitle.textContent = albumTitle.textContent;
            }
          }

          let activeGridPhotos = null;

          if ('useCategories' in dropdownList.dataset) {
            const activeCategory = this.getActiveCategory();

            activeGridPhotos = [...filterGridPhotos].find(filterGridPhoto => filterGridPhoto.dataset.filterTags === e.target.dataset.filter && activeCategory === filterGridPhoto.dataset.category);
          } else {
            activeGridPhotos = [...filterGridPhotos].find(filterGridPhoto => filterGridPhoto.dataset.filterTags === e.target.dataset.filter);
          }

          if (activeGridPhotos) {
            const imgs = activeGridPhotos.querySelectorAll('img');
            photoCounter.count = imgs.length;
            imgs.forEach(img => LazyLoad.load(img, {}));
          }
          const photoCount = document.querySelector('[data-cover-count-photo]');
          if (photoCount) {
            photoCount.textContent = photoCounter.count;
          }
          if (coverBg && e.target.dataset.imageSrc) {
            coverBg.src = e.target.dataset.imageSrc;
          }

          const activeItem = [...spanItems].find(span => span.dataset.dropdownTitleItem === e.target.dataset.filter);
          if (activeItem) {
            dropdownTitle.textContent = activeItem.textContent;
          }

          const activeSignature = [...signatures].find(signature => signature.dataset.coverSignatureType === 'photo');
          if (activeSignature) {
            activeSignature.classList.remove('hide');
          } else {
            signatures.forEach((signature) => {
              signature.classList.add('hide');
            });
          }
        });
      }
    });
    const photoCounters = document.querySelectorAll('[data-count-photo]');
    const dropdownList = document.querySelector('[data-dropdown-list]');

    this.photosContainer.forEach((photo) => {
      let activeItem;

      if ('useCategories' in dropdownList.dataset) {
        activeItem = [...photoCounters].find(counter => counter.dataset.category === photo.dataset.category && counter.dataset.countPhoto === photo.dataset.filterTags);
      } else {
        activeItem = [...photoCounters].find(counter => counter.dataset.countPhoto === photo.dataset.filterTags);
      }

      const images = photo.querySelectorAll('img');
      activeItem.textContent = images.length;
    });

    this.initGrid();
    this.initFilters();
    this.masonry();
    this.filterItems[0].classList.add(this.activeClass);
    this.filterBy = this.filterItems[0].dataset.filter;
    this.filter();
    window.addEventListener('resize', this.updateGrid_debounced);
    if (this.lineController) this.lineController.dispatchEvent(createEvent('updateLine'));
  }
}



// WEBPACK FOOTER //
// ./components/TabFilters/TabFilters.js